import { library } from "@fortawesome/fontawesome-svg-core";
import { faCirclePlus, faCircleMinus, faUtensils, faAnglesRight, faRightFromBracket,
    faUser, faBookOpen, faBookOpenReader, faSquareCheck, faHandPointer} from "@fortawesome/free-solid-svg-icons";;

    library.add(faCirclePlus, faCircleMinus, faUtensils, faAnglesRight, 
        faRightFromBracket, faUser, faBookOpenReader, faSquareCheck, faHandPointer);